'use strict';

// Mirrors webpayment's app/composables/useDmtFormat.ts so amounts/dates/masks
// read identically to the merchant dashboard.

function formatCurrency(val) {
  return '₹' + Number(val ?? 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function formatCurrencyShort(val) {
  return '₹' + Number(val ?? 0).toLocaleString('en-IN');
}

function maskAccount(accNo) {
  if (!accNo) return '—';
  const s = String(accNo);
  return s.length <= 4 ? s : 'XXXXXX' + s.slice(-4);
}

function maskAadhaar(aadhaar) {
  if (!aadhaar) return '—';
  const digits = String(aadhaar).replace(/\D/g, '');
  return digits.length >= 4 ? 'XXXX XXXX ' + digits.slice(-4) : 'XXXX XXXX XXXX';
}

function maskMobile(mobile) {
  if (!mobile) return '—';
  const s = String(mobile);
  return s.length <= 4 ? s : 'XXXXXX' + s.slice(-4);
}

function formatDateTime(d) {
  return new Date(d).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

module.exports = { formatCurrency, formatCurrencyShort, maskAccount, maskAadhaar, maskMobile, formatDateTime };
